import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaShoppingBag, FaHome, FaBoxOpen } from 'react-icons/fa';
import './OrderSuccess.css';

const OrderSuccess = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const orderId = location.state?.orderId;
    const shippingInfo = location.state?.shippingInfo;
    const totalAmount = location.state?.totalAmount;

    const currentDate = new Date().toLocaleDateString('en-US', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
    });

    return (
        <div className="order-success">
            <div className="success-container">
                {/* Header Section */}
                <div className="success-header">
                    <FaCheckCircle className="success-icon" />
                    <h1>🎉 Order Confirmed!</h1>
                    <p className="success-subtitle">Thank you for shopping with NepliShop</p>
                </div>

                {/* Success Message */}
                <div className="success-message">
                    <p>Your order has been successfully placed and is being processed.</p>
                    <p className="delivery-note">
                        <FaBoxOpen className="message-icon" />
                        You'll receive a confirmation email shortly with tracking details.
                    </p>
                </div>

                {/* Order Details Card */}
                <div className="order-details-card">
                    <div className="card-header">
                        <h3>📦 Order Details</h3>
                    </div>
                    
                    <div className="order-info-grid">
                        <div className="info-item">
                            <span className="info-label">Order ID:</span>
                            <span className="info-value order-id">#{orderId || 'N/A'}</span>
                        </div>
                        
                        <div className="info-item">
                            <span className="info-label">Order Date:</span>
                            <span className="info-value">{currentDate}</span>
                        </div>
                        
                        <div className="info-item">
                            <span className="info-label">Total Amount:</span>
                            <span className="info-value total-amount">Rs {totalAmount || '0.00'}</span>
                        </div>
                        
                        <div className="info-item">
                            <span className="info-label">Payment Method:</span>
                            <span className="info-value payment-method">Cash on Delivery</span>
                        </div>
                    </div>
                </div>

                {/* Shipping Information */}
                {shippingInfo && (
                    <div className="shipping-info-card">
                        <div className="card-header">
                            <h3>🚚 Shipping Information</h3>
                        </div>
                        
                        <div className="shipping-details">
                            <div className="shipping-item">
                                <span className="shipping-label">Recipient:</span>
                                <span className="shipping-value">{shippingInfo.name}</span>
                            </div>
                            
                            <div className="shipping-item">
                                <span className="shipping-label">Address:</span>
                                <span className="shipping-value">{shippingInfo.address}</span>
                            </div>
                            
                            <div className="shipping-item">
                                <span className="shipping-label">Phone:</span>
                                <span className="shipping-value">{shippingInfo.phone}</span>
                            </div>
                            
                            <div className="shipping-item">
                                <span className="shipping-label">Email:</span>
                                <span className="shipping-value">{shippingInfo.email}</span>
                            </div>
                        </div>
                    </div>
                )}

                {/* Next Steps */}
          

                {/* Action Buttons */}
                <div className="success-actions">
                    <button onClick={() => navigate('/')} className="continue-shopping-btn">
                        <FaShoppingBag className="btn-icon" />
                        Continue Shopping
                    </button>
                    
                    <button onClick={() => navigate('/')} className="home-btn">
                        <FaHome className="btn-icon" />
                        Back to Home
                    </button>
                </div>

                {/* Support Info */}
                <div className="support-info">
                    <p>Need help? Contact our customer support at <strong>neplishop.com@gmail.com</strong> or call <strong>+977 9741761406</strong></p>
                </div>
            </div>
        </div>
    );
};

export default OrderSuccess;
